import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { notificationDetailLoad } from 'store/models/notification';
import { DetailLoadComponent } from 'components/common';

const NotificationValue = (props) => {
  return (
    <DetailLoadComponent
      apiLoad={notificationDetailLoad(props.site.activeDomain)}
      {...props}
      getDetailUrl={(id, item) => props.model.urls.detail(id)}
      render={({ id, item, linkPath }) => {
        const value = (item && item.to_email) || id;

        return (
          <Fragment>{props.asLink && linkPath ? <Link to={linkPath}>{value}</Link> : <span>{value}</span>}</Fragment>
        );
      }}
    />
  );
};

const mapState = (state) => ({
  router: state.router,
  authToken: state.auth.token,
  model: state.notification,
  site: state.site,
});

export default connect(mapState)(NotificationValue);
